






































import { Component, Prop, Vue } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";
import { IContractProduct } from "@/models/contracts";
import i18n from "@/i18n";

@Component({
  components: {
    "cprod-grid-item": () =>
      import("@/components/app/global/contractProducts/cProdGridItem.vue")
  }
})
export default class SelectClientContractProduct extends Vue {
  // Props

  @Prop({ required: true })
  public value;

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: () => ({}) })
  public product!: IContractProduct;

  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ default: i18n.t("_action.select_product") })
  public selectAction!: string;

  @Prop({ required: true })
  public redirect!: boolean;

  // Data

  public contractProduct = {} as IContractProduct;

  // Computed

  public get contractProductId() {
    return this.value;
  }

  public set contractProductId(value) {
    this.$emit("input", value);
  }

  // Life-cycle methods

  public async created() {
    if (!this.$_.isEmpty(this.product)) {
      this.contractProduct = this.product;
    }
  }

  // Methods

  public openSelectProductModal() {
    if (this.isProcessing) return;
    this.$store.dispatch(
      `data/${DataModules.CONTRACTS}/openSelectClientProductModal`,
      {
        props: {
          accountId: this.accountId
        },
        events: {
          success: contractProduct => {
            this.contractProductId = contractProduct.id;
            this.$set(this, "contractProduct", {
              ...contractProduct,
              client_id: this.clientId
            });
          }
        }
      }
    );
  }

  public removeSelection() {
    this.contractProductId = null;
    this.$set(this, "contractProduct", {});
  }
}
